import script from "./Expertise.vue?vue&type=script&setup=true&lang=js"
export * from "./Expertise.vue?vue&type=script&setup=true&lang=js"

import "./Expertise.vue?vue&type=style&index=0&id=a47572ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a47572ba"]])

export default __exports__